import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

/**
 * lightweight wrappers around Next.js’ navigation APIs that automatically handle the user locale and pathnames behind the scenes
 * see https://next-intl.dev/docs/routing/navigation
 */
export const { Link, redirect, permanentRedirect, usePathname, useRouter, getPathname } = createNavigation(routing);
